import $ from 'jquery';


class FormButtonHandler {
  constructor() {
    this.postCallbacks = [];
    this.postQueue = [];
  }

  listen() {
    $(document).on('submit', 'form', (event) => {
      const $btn = $(event.currentTarget).find("button[type='submit']");
      this.applyBusyStyling($btn);
    });
  }

  applyBusyStyling(element) {
    const $el = $(element);

    if ($el.length === 0) {
      return;
    }

    const buttonText = $el.html().trim();
    const waitingIcon = '<span class="tn-waiting"></span>';

    $el.html(buttonText + waitingIcon);

    $el.prop('disabled', true);

    this.callPosts(this.postCallbacks);
    this.callPosts(this.postQueue);
  }

  queuePost(callback) {
    this.postQueue.push(callback);
  }

  post(callback) {
    this.postCallbacks.push(callback);
  }

  callPosts(postArray) {
    postArray.forEach((cb) => {
      try {
        cb();
      } catch (err) {
        console.log(err);
      }
    });
  }

  resetButtonStyling() {
    const $btn = $("button[type='submit']");

    $btn.prop('disabled', false);

    const $icon = $($btn).find('span.tn-waiting');
    $icon.remove();
  }

  resetStyling(element) {
    const $el = $(element);
    const $icon = $el.find('span.tn-waiting');

    $icon.remove();

    $el.prop('disabled', false);
  }

}

export default FormButtonHandler;



// WEBPACK FOOTER //
// ./V7/tnew/handlers/FormButtonHandler.js